import type { SVGProps } from 'react';

export function IconXMark(props: SVGProps<SVGSVGElement>) {
    return (
        <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M0.263672 1.43402C-0.0878906 1.1173 -0.0878906 0.554252 0.263672 0.237537C0.580078 -0.0791789 1.10742 -0.0791789 1.45898 0.237537L9.01758 7.80352L16.5762 0.237537C16.8926 -0.0791789 17.4199 -0.0791789 17.7363 0.237537C18.0879 0.554252 18.0879 1.1173 17.7363 1.43402L10.1777 9L17.7363 16.566C18.0879 16.8827 18.0879 17.4457 17.7363 17.7625C17.4199 18.0792 16.8926 18.0792 16.5762 17.7625L9.01758 10.1965L1.45898 17.7625C1.10742 18.0792 0.580078 18.0792 0.263672 17.7625C-0.0878906 17.4106 -0.0878906 16.8827 0.263672 16.566L7.82227 9L0.263672 1.43402Z"
                fill="currentColor"
            />
        </svg>
    );
}
